export default [
  {
    path: "/not-found",
    name: "404",
    meta: { title: "Page not found" },
    component: () => import(/* webpackChunkName: "404 View" */ "@/Modules/404/Views")
  }
]
